import ReviewsDialog from "./ReviewsDialog";

export default ReviewsDialog;
